import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Box, FormField, Modal } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import CodenameService from "services/common/codename.service";

import { setDataAlert, showLoading } from "store/slice/common.slice";
import { getGroupName } from ".";



const codenameService = new CodenameService();

const ModalCreateUpdateCodeName = ({
    id,
    visible,
    group,
    serviceCode,
    organizationId,
    setVisible,
    onCallBack,
}: {
    id: string;
    visible: boolean;
    group?: string;
    serviceCode?: string;
    organizationId?: string;
    onCallBack: () => void;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

    const dispatch = useDispatch();
    const [errorDetail, setErrorDetail] = useState<{
        code?: string,
        name?: string,
    }>({});
    const [dataDetail, setDataDetail] = useState<{
        id?: string;
        code?: string,
        name?: string,
        group?: string,
        shortName?: string,
        updateTime?: string,
        serviceCode?: string,
        organizationId?: string,
    }>({});

    useEffect(() => {
        if (!Helpers.isNullOrEmpty(id) && visible) {
            (async () => {
                try {
                    dispatch(showLoading(true));

                    const result = await codenameService.getDetail(id);

                    setErrorDetail({});
                    setDataDetail({
                        id: result.id,
                        name: result.name,
                        code: result.code,
                        group: result.group,
                        shortName: result.shortName,
                        updateTime: result.updateTime,
                        serviceCode: result.serviceCode,
                        organizationId: result.organizationId,
                    });

                } catch (error) {
                    const err = Helpers.handleExceptionError(error);
                    !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
                } finally {
                    dispatch(showLoading(false));
                }
            })();
        }
    }, [visible, id]);

    const handleClose = () => {
        setVisible(false);
        setDataDetail({});
        setErrorDetail({});
    };

    const handleValidate = () => {
        let checked = true;
        let newError = { ...errorDetail };

        if (Helpers.isNullOrEmpty(dataDetail?.name)) {
            checked = false;
            newError["name"] = Strings.SETTING.PLEASE_ENTER_NAME;
        }
        if (Helpers.isNullOrEmpty(dataDetail?.code)) {
            checked = false;
            newError["code"] = Strings.SETTING.PLEASE_ENTER_CODE;
        }

        if (!checked) {
            setErrorDetail(newError);
        }

        return checked;
    };

    const handleSubmit = async () => {
        if (!handleValidate()) {
            return;
        } else {
            try {
                dispatch(showLoading(true));

                let message = "";
                if (Helpers.isNullOrEmpty(dataDetail?.id)) {
                    await codenameService.create({
                        name: dataDetail?.name,
                        code: dataDetail?.code,
                        group: group,
                        serviceCode: serviceCode,
                        organizationId: organizationId,

                    });

                    message = Strings.SETTING.CREATE_SUCCESS;
                } else {
                    await codenameService.update({
                        id: dataDetail?.id,
                        name: dataDetail?.name,
                        code: dataDetail?.code,
                        group: dataDetail?.group,
                        shortName: dataDetail?.shortName,
                        updateTime: dataDetail?.updateTime,
                        serviceCode: dataDetail?.serviceCode,
                        organizationId: dataDetail?.organizationId,
                    });

                    message = Strings.SETTING.UPDATE_SUCCESS;
                }

                dispatch(setDataAlert({ message, type: "success" }));
                handleClose();
                onCallBack();
            } catch (error) {
                const err = Helpers.handleExceptionError(error);
                !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
            } finally {
                dispatch(showLoading(false));
            }
        }
    };

    return (
        <Modal
            fullWidth
            hasActionButton
            maxWidth={"sm"}
            visible={visible}
            onClose={() => { handleClose(); }}
            onAction={() => { handleSubmit(); }}
            title={Helpers.isNullOrEmpty(dataDetail?.id) ? Strings.COMMON.ADD_NEW : Strings.COMMON.EDIT}
        >
            <Box padding={"24px 16px"}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormField
                            required
                            variant={"outlined"}
                            value={dataDetail?.code || ""}
                            errorMessage={errorDetail?.code || ""}
                            label={Strings.SETTING.CODE}
                            placeholder={Strings.SETTING.ENTER_CODE}
                            onChangeValue={(value) => {
                                setErrorDetail(prev => ({
                                    ...prev,
                                    code: undefined,
                                }));
                                setDataDetail(prev => ({
                                    ...prev,
                                    code: value,
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            required
                            variant={"outlined"}
                            value={dataDetail?.name || ""}
                            errorMessage={errorDetail?.name || ""}
                            label={Strings.SETTING.NAME}
                            placeholder={Strings.SETTING.ENTER_NAME}
                            onChangeValue={(value) => {
                                setErrorDetail(prev => ({
                                    ...prev,
                                    name: undefined,
                                }));
                                setDataDetail(prev => ({
                                    ...prev,
                                    name: value,
                                }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            disabled
                            variant={"outlined"}
                            value={getGroupName(group)}
                            label={Strings.SETTING.GROUP_NAME}
                            onChangeValue={(value) => { }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
}

export default ModalCreateUpdateCodeName;